import angular from 'angular';
import companyOwners from './companyOwners';

export default angular
  .module('components.companyOwners', [])
  .component('companyOwners', companyOwners).name;
